import Box from "@@/elements/Box";
import Typhography from "@@/elements/Typography";
import cn from "classnames";
import styles from "./optionStyles.module.scss";

type ClearButtonProps = {
  id: string;
  isActive: boolean;
  text: string;
  handleChange: Function;
  disabled?: boolean;
};

const ClearButton = ({ id, isActive, text, handleChange, disabled } : ClearButtonProps) => (
  <Box
    id={id}
    className={cn(styles.option, { [styles.option__active]: isActive })}
    aria-label={text}
    role="option"
  >
    <input onClick={() => handleChange(null)} type="button" tabIndex={-1} disabled={disabled} />
    <Box className={cn(styles.container, styles.container__clearbutton)}>
      <Typhography variant="label" asElement="div" uppercase>
        {text}
      </Typhography>
    </Box>
  </Box>
);

export default ClearButton;
